import { z } from 'zod';
import { RuleTargetZod } from './rule.target.zod';
import { JsonValueZod } from './json.value.zod';

const RuleEffectBaseZod = z.discriminatedUnion('effect', [
  z.object({ effect: z.literal('hide'), target: RuleTargetZod }).strict(),
  z.object({ effect: z.literal('show'), target: RuleTargetZod }).strict(),
  z.object({ effect: z.literal('readonly'), target: RuleTargetZod, value: z.boolean().optional() }).strict(),
  z.object({ effect: z.literal('disabled'), target: RuleTargetZod, value: z.boolean().optional() }).strict(),
  z.object({ effect: z.literal('required'), target: RuleTargetZod, value: z.boolean().optional() }).strict(),
  z.object({ effect: z.literal('validatorConfig'), target: RuleTargetZod, validator: z.string().min(1), config: z.record(z.string(), JsonValueZod).optional(), message: z.string().optional(), enabled: z.boolean().optional() }).strict(),
  z.object({ effect: z.literal('editorConfig'), target: RuleTargetZod, config: z.record(z.string(), JsonValueZod) }).strict(),
  z.object({ effect: z.literal('setValue'), target: RuleTargetZod, value: JsonValueZod.optional(), fromBind: z.string().min(1).optional() }).strict(),
  z.object({ effect: z.literal('setTitle'), target: RuleTargetZod, value: z.string().optional(), fromBind: z.string().min(1).optional() }).strict(),
  z.object({ effect: z.literal('clearValue'), target: RuleTargetZod }).strict(),
  z.object({ effect: z.literal('custom'), target: RuleTargetZod, key: z.string().min(1), config: z.record(z.string(), JsonValueZod).optional() }).strict(),
]);

export const RuleEffectZod = RuleEffectBaseZod.superRefine((effect, ctx) => {
  if (effect.effect !== 'setValue' && effect.effect !== 'setTitle') return;
  const hasValue = Object.prototype.hasOwnProperty.call(effect, 'value');
  const hasFromBind = effect.fromBind !== undefined;
  if (hasValue === hasFromBind) {
    ctx.addIssue({ code: 'custom', message: `${effect.effect} requires exactly one of value or fromBind.` });
  }
});

export type RuleEffect = z.infer<typeof RuleEffectZod>;
